export var WeekPlannerFilterType;
(function (WeekPlannerFilterType) {
    WeekPlannerFilterType["taskTemplates"] = "taskTemplates";
    WeekPlannerFilterType["userId"] = "userId";
    WeekPlannerFilterType["status"] = "status";
    WeekPlannerFilterType["executionDateFrom"] = "executionDateFrom";
    WeekPlannerFilterType["executionDateUntil"] = "executionDateUntil";
})(WeekPlannerFilterType || (WeekPlannerFilterType = {}));
